module.exports = __webpack_public_path__ + "static/mami-8692b7ee77ab3de28c2151a5419354e9.jpg";